<h2 mat-dialog-title>{{ 'VOUCHER.MODAL_CLIENT_SECRET.TITLE' | translate }}</h2>
<mat-dialog-content>
  <p>{{ 'VOUCHER.MODAL_CLIENT_SECRET.BODY' | translate }}</p>
  <p class="font-weight-bold">
    {{ 'VOUCHER.MODAL_CLIENT_SECRET.CLIENT_SECRET' | translate }}
    <span class="font-weight-bolder">{{ data.client_secret }}</span>
  </p>
</mat-dialog-content>
<mat-dialog-actions>
  <button mat-button (click)="close()">
    {{ 'VOUCHER.MODAL_CLIENT_SECRET.CLOSE' | translate }}
  </button>
</mat-dialog-actions>
